import React, { useEffect, useState } from 'react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-34">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oSx3NjfBM2Xg7sDJpNb5yW/GrowthLyfe_Logo.png" alt="Growthlyfe Logo" className="h-8 md:h-10" data-id="element-35" />
        <button onClick={scrollToContact} className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-colors duration-200" data-id="element-36">
          Get Started
        </button>
      </div>
    </header>;
}